import React, { useState, useEffect } from "react";
// import { FaArrowUp } from "react-icons/fa";
import "./ScrollToTop.css";
import { motion } from "framer-motion";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      className={`scroll-to-top ${isVisible ? "" : "hidden"}`}
      onClick={scrollToTop}
    >
      <i className="ri-arrow-up-line" />
    </button>
  );
};

export default ScrollToTop;
